export default "__VITE_ASSET__CcZ_KYWl__";